import {Injectable} from '@angular/core';
import {ApiService} from '../api/api.service';
import {Observable} from 'rxjs';
import _get from 'lodash/get';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  constructor(private api: ApiService) {
  }

  public sendLink(id, type, method, template): Observable<any> {
    return this.api.post('/payment/' + type + '/' + id + '/' + method, {
      body: Object.assign(template, _get(template, ['instalment', 'items']) ? {has_instalments: true} : {})
    });
  }

  public sendLinkV2(id, type, method, template, assigned_by): Observable<any> {
    return this.api.post('/payment/v2/' + type + '/' + id + '/' + method, {
      body: Object.assign(template, _get(template, ['instalment', 'items']) ? {has_instalments: true} : {}, {assigned_by: assigned_by})
    });
  }

  public checkEmail(related_id, related_type, email) {
    return this.api.post(`/payment/${related_type}/${related_id}/check/valid`, {
      body: {
        email: email
      }
    });
  }

  public detectType(method, account_number, products) {
    return this.api.post(`/payment/detect/${method}/${account_number}`, {
      body: {
        products
      }
    });
  }

  public detectInstalment(product, lead_number) {
    return this.api.post(`/payment/detect-instalment/${lead_number}`, {
      body: {
        product
      }
    });
  }

  public getNotifications(params): Observable<any> {
    return this.api.get('/payment/notifications', {
      params
    });
  }

  public getTransactions(params): Observable<any> {
    return this.api.get('/payment/transactions', {
      params
    });
  }

  public getAvailableMethods(country, accountNumber, campaignSource, paymentProduct, mid, paymentType, additionalParams): Observable<any> {
    let path = `/payment/available-methods?country=${country}&account_number=${accountNumber}&campaign_source=${campaignSource}&product_name=${paymentProduct}&payment_mid=${mid}&payment_type=${paymentType}`;

    if(additionalParams) {
      path += this.convertToPaymentParams(additionalParams);
    }

    return this.api.get(path, {});
  }

  public getPartialOpportunities(accountNumber): Observable<any> {
    return this.api.get('/payment/detect-partial/' + accountNumber + '?new=1', {});
  }

  public makeFakePayment(data) {
    return this.api.post('/payment/fake-payment', {
      body: data
    });
  }

  public unlockCascading(data) {
    return this.api.post('/payment/unlock-cascading', {
      body: data
    });
  }

  public discount(opportunityId: number): Observable<any> {
    return this.api.post('/payment/discount/' + opportunityId, {});
  }

  public sendReceipt(id: string): Observable<any> {
    return this.api.post(`/payment/send-receipt/${id}`, {});
  }

  public getSpouses (accNumber: string): Observable<any> {
    return this.api.get('/spouses/' + accNumber, {});
  }

  public getTransactionHistory(id: string, params: any): Observable<any> {
    return this.api.get(`/payment/${id}/history`, { params });
  }

  private convertToPaymentParams(params, root = 'payment_params') {
    const queryParts = [];
  
    for (const [provider, fields] of Object.entries(params)) {
      for (const [key, value] of Object.entries(fields)) {
        const encodedValue = encodeURIComponent(`${value}`); 
        queryParts.push(`${root}[${provider}][${key}]=${encodedValue}`);
      }
    }
  
    return '&' + queryParts.join('&');
  }
}
